import { ArenaModel } from "./arena.model";
import { HoundModel } from "./hound.model";

export class RaceModel {
  id: number;
  chain_id: number;
  race_id: string;
  queue_id: string;
  name: string;
  entryFee: string;
  entryFeeCurrency: string;
  randomness: string;
  seed: number;
  cooldown: number;
  dbArenaId: number;
  arena: ArenaModel;
  participants: HoundModel[] = [];
  ordered_participants: string;
  payments: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(race: Partial<RaceModel> = {}) {
    this.id = race.id!;
    this.chain_id = race.chain_id;
    this.race_id = race.race_id!;
    this.queue_id = race.queue_id!;
    this.name = race.name!;
    this.entryFee = race.entryFee!;
    this.entryFeeCurrency = race.entryFeeCurrency!;
    this.seed = race.seed!;
    this.dbArenaId = race.dbArenaId!; 
    this.arena = new ArenaModel(race.arena);
    this.ordered_participants = race.ordered_participants!;
    this.randomness = race.randomness;
    this.payments = race.payments;
    this.createdAt = race.createdAt;
    this.updatedAt = race.updatedAt;
    race.participants?.forEach(e => {
      this.participants.push(new HoundModel(e));
    });
  }

}
